/**
 * Variant knobs for Pusoy. The evaluator never branches on these; scoring,
 * naturals and the auto-arranger do.
 *
 * The numbers are the sibling app's `DEFAULTS`, value for value. They are a
 * golden anchor — the vectors assert exact unit totals against them, so moving
 * one is a rules change that needs its own decision, not a tweak.
 *
 * Rulesets are NAMED, not dialled. A Kubo host picking royalties per table
 * means a table that scores by different rules than the lobby advertised, and
 * that is a chip dispute; adding a variant is a new entry here plus its own
 * vector file.
 */
export const NATURAL_KEYS = [
    'cleanDragon',
    'dragon',
    'threeStraightFlush',
    'threeFlush',
    'threeStraight',
    'sixPairs',
];
/** Display names for the results screen. Units come from the ruleset, never here. */
export const NATURAL_META = {
    cleanDragon: { en: 'Clean dragon', tl: 'Malinis na dragon' },
    dragon: { en: 'Dragon', tl: 'Dragon' },
    threeStraightFlush: { en: 'Three straight flushes', tl: 'Tatlong straight flush' },
    threeFlush: { en: 'Three flushes', tl: 'Tatlong flush' },
    threeStraight: { en: 'Three straights', tl: 'Tatlong straight' },
    sixPairs: { en: 'Six pairs', tl: 'Anim na pares' },
};
export const STANDARD = {
    key: 'standard',
    scoopBonus: 3,
    royaltyMode: 'vsAll',
    royalties: {
        back: { straight: 2, flush: 4, fullHouse: 6, quads: 8, straightFlush: 10 },
        middle: { fullHouse: 2, quads: 8, straightFlush: 10 },
        front: { trips: 3 },
    },
    naturals: {
        cleanDragon: { on: false, units: 26, prec: 8 },
        dragon: { on: true, units: 13, prec: 7 },
        threeStraightFlush: { on: false, units: 10, prec: 6 },
        threeFlush: { on: true, units: 6, prec: 4 },
        threeStraight: { on: true, units: 6, prec: 3 },
        sixPairs: { on: true, units: 6, prec: 2 },
    },
    wRows: 1.0,
    wRoyalty: 0.15,
};
/**
 * The full catalogue: the two naturals the reference ships switched off — a
 * dragon in one suit, and three straight flushes — are live here. Both are rare
 * enough that a table which never sees one is the normal case, which is exactly
 * why they are a separate ruleset rather than a default nobody tested.
 */
export const KUMPLETO = {
    ...STANDARD,
    key: 'kumpleto',
    naturals: {
        ...STANDARD.naturals,
        cleanDragon: { on: true, units: 26, prec: 8 },
        threeStraightFlush: { on: true, units: 10, prec: 6 },
    },
};
export const RULESETS = {
    standard: STANDARD,
    kumpleto: KUMPLETO,
};
/**
 * Resolve `InitOptions.ruleset`. No key is the standard table; a NAMED key that
 * does not exist throws rather than falling back, because a table sold as one
 * ruleset and scored as another is a chip dispute and table creation is the
 * cheap place to find out.
 */
export function resolveRuleset(raw) {
    const key = raw?.['key'];
    if (key === undefined || key === null)
        return STANDARD;
    if (typeof key !== 'string')
        throw new Error('pusoy: ruleset.key must be a string');
    const found = RULESETS[key];
    if (!found)
        throw new Error(`pusoy: walang ruleset na "${key}"`);
    return found;
}
//# sourceMappingURL=ruleset.js.map